import React from 'react';

const CancellationAndRefundPolicy = () => {
  return (
    <div className="policy-container">
      <h1>🚫 Cancellation & Refund Policy</h1>
      <p><strong>Effective Date:</strong> 12 June 2025</p>
      <p>We follow a strict no-refund policy for all digital products and course enrollments due to the nature of our services.</p>
      <h3>1. No Refunds</h3>
      <p>Once a course has been purchased, no cancellations or refunds will be provided under any circumstances.</p>
      <h3>2. Non-transferable</h3>
      <p>Course access is granted only to the registered user and is non-transferable.</p>
      <h3>3. Course Modifications</h3>
      <p>We reserve the right to modify or update course content to improve quality or user experience. No refunds will be issued for such updates or changes.</p>
    </div>
  );
};

export default CancellationAndRefundPolicy;
